/**
 * @module api-web:taxType
 * @description api for basic/taxType
 */
import service from '@/service'

/**
 * 税率信息   表查询
 * @param {{keywords:string,limit:number,page:number,sort:string,documentStatus:number}} params
 */
export function getList(params) {
  return service['api-web']({
    url: '/data/basic/taxType/getList',
    method: 'get',
    params
  })
}

/**
 * 税率信息 详情
 */
export function info(id) {
  return service['api-web']({
    url: '/data/basic/taxType/info',
    method: 'get',
    params: { id }
  })
}
/**
 * 待办详情 (无需权限)
 */
export function todoInfo(id) {
  return service['api-web']({
    url: '/public/activiti/taxType/info',
    method: 'get',
    params: { id }
  })
}
/**
 * 税率信息   新增
 */
export function create(data) {
  return service['api-web']({
    url: '/data/basic/taxType/save',
    method: 'post',
    data
  })
}

/**
 * 税率信息   修改
 */
export function update(data) {
  return service['api-web']({
    url: '/data/basic/taxType/update',
    method: 'post',
    data
  })
}
/**
 * @param {object}
 * @returns 审核驳回
 */
export function reject(data) {
  return service['api-web']({
    // url: '/data/basic/taxType/reject',
    url: '/public/activiti/taxType/reject',
    method: 'post',
    data,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

/**
 * @param {(string|number)} ids
 * @description 结束流程（结束审核流）
 */
export function withdraw(ids) {
  return service['api-web']({
    url: '/data/basic/taxType/withdraw',
    method: 'post',
    data: { ids },
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

/**
 * 提交
 * @param {{ids:string}} ids
 */
export function submit(ids) {
  return service['api-web']({
    url: '/data/basic/taxType/submit',
    method: 'post',
    data: { ids },
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}
/**
 * 启用禁用
 * @param {(string|number)} id - id
 * @param {(0|1)} status - 0:禁用 1:启用
 */
export function enableDisable(data) {
  return service['api-web']({
    url: '/data/basic/taxType/updateDisableStatus',
    method: 'post',
    data,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}
